import { getItem, setItem } from './local-storage';

function storageKey(preferenceName) {
  return `PREFERENCE:${preferenceName}`;
}

export function setPreference(preferenceName, value) {
  setItem(storageKey(preferenceName), value);
}

export function getPreference(preferenceName) {
  return getItem(storageKey(preferenceName));
}
